// Core modules imports are same as usual
import { Navigation, Pagination, EffectCreative, Autoplay } from 'swiper';
// Direct React component imports
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import { Grid } from 'antd';
import { Swiper as SwiperOptions } from 'swiper/types';
import { useEffect } from 'react';
// import { isLocaleEnglish } from 'utils/languageUtils';
// import { useTranslation } from 'react-i18next';
// Styles must use direct files imports
import 'swiper/swiper.less'; // core Swiper
import 'swiper/modules/navigation/navigation.less'; // Navigation module
import 'swiper/modules/pagination/pagination.less'; // Pagination module
import './SwiperBanner.less';
import { NewsProps } from 'utils/liHome';
import { default as NewsCard } from './NewsSection';
import { useState } from 'react';
const { useBreakpoint } = Grid;
type SwiperPageProps = {
  news?: NewsProps[];
  num?: number;
};
const SwiperPage = ({ news, num }: SwiperPageProps) => {
  const { xl, lg, md } = useBreakpoint();
  const [mySwiper, setMySwiper] = useState<SwiperOptions | null>(null);
  // const { i18n } = useTranslation();

  // const isEnglish = isLocaleEnglish(i18n.language);

  const updateCreativeEffectTranslate = (
    newPrevTranslateValue: number | string,
    newNextTranslateValue: number | string,
    newLimitProgress: number,
  ) => {
    if (mySwiper && mySwiper.params && mySwiper.params.creativeEffect) {
      if (mySwiper.params.creativeEffect.prev && mySwiper.params.creativeEffect.prev.translate)
        mySwiper.params.creativeEffect.prev.translate = [newPrevTranslateValue, 0, 0];
      if (mySwiper.params.creativeEffect.next && mySwiper.params.creativeEffect.next.translate)
        mySwiper.params.creativeEffect.next.translate = [newNextTranslateValue, 0, 0];
      if (mySwiper.params.creativeEffect.limitProgress) mySwiper.params.creativeEffect.limitProgress = newLimitProgress;
      mySwiper.update();
    }
    // 更新Swiper参数
  };
  useEffect(() => {
    if (xl) {
      updateCreativeEffectTranslate('-41.5%', '41.5%', 2);
    } else if (lg) {
      updateCreativeEffectTranslate('-35%', '35%', 2);
    } else if (md) updateCreativeEffectTranslate('-20%', '20%', 1);
    else updateCreativeEffectTranslate(0, 0, 1);
  });

  useEffect(() => {
    if (mySwiper && num != undefined) {
      mySwiper.slideTo(num); // 跳转到第三个slide
    }
  }, [num, mySwiper]);
  return (
    <div style={{ width: '80%', height: '256px', margin: 'auto' }}>
      <Swiper
        loop={true} //设置循环轮播
        className="mySwiper"
        spaceBetween={-200} //设置堆叠轮播，item之间叠的距离
        slidesPerView="auto" //设置显示的数量
        navigation={true} //modules上加了同时要设置为true，才显示
        modules={[Navigation, Pagination, EffectCreative, Autoplay]}
        pagination={{ clickable: true }}
        grabCursor={true}
        effect={'creative'} //modules上加了同时要设置
        centeredSlides={true} // 居中的slide是否标记为active，默认是最左active,这样样式即可生效
        slideToClickedSlide={false} // 点击的slide会居中
        creativeEffect={{
          prev: {
            //这里是设置当前item的前一项的具体属性
            translate: ['-50%', 0, 0], //偏移量，三个轴，X、Y、Z
            scale: 0.8, //缩放量
            // opacity:0.8,//透明度
            // shadow:true,//是否加阴影
            //rotate:30,//item旋转角度
            //origin:'left bottom'//item位于左下还是哪里
          },
          next: {
            //这里是设置当前item的后一项的具体属性，同上面
            translate: ['50%', 0, 0],
            scale: 0.8,
            // opacity:0.8,
            // shadow:true,
          },
          limitProgress: 1, //显示五个堆叠的最重要的这个属性，后面依次以前面属性等比配置
          // shadowPerProgress:true,//是否等比配置透明度
        }}
        onSwiper={(swiper) => {
          setMySwiper(swiper);
        }}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
          stopOnLastSlide: false,
        }}
      >
        {news?.map((item, index) => {
          return (
            <SwiperSlide key={index} style={{ maxWidth: 494 }}>
              <div className="swiper-img" style={{ width: '100%', height: '100%' }}>
                <div className="image-new">
                  <img src={item.imageUrlSquare} alt="" />
                </div>
                <div className="desc-right">
                  <p className="title-date">
                    <span className="title">{item.title}</span>
                    {/* <span className="date">{item.publishTime}</span> */}
                  </p>
                  <p className="desc">{item.description}</p>
                  <NewsCard url={item.url} />
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};
export default SwiperPage;
